<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">角色管理</h2>
        <el-button type="primary" size="mini" class="el-icon-plus newRole" :disabled="auths.indexOf(2) < 0"
                   @click="createNewRoleModalTrue">&nbsp创建角色
        </el-button>
      </div>
      <div class="common-search">
        <el-form :inline="true" label-width="60px" class="formInline" size="mini">
          <el-form-item label="角色">
            <el-input v-model="formData.roleName" placeholder="请输入角色名称..." :maxlength="12"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="search-btn" @click="getData">筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table class="limitManagerTable table-expand" style="width: 100%" :data="tableData" ref="table" size="small"
                  v-loading="listLoading" element-loading-text="拼命加载中" border header-row-class-name="table-header">
          <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
          <el-table-column prop="roleName" label="角色名称" align="center"></el-table-column>
          <el-table-column prop="roleRemark" label="备注" align="center"></el-table-column>
          <el-table-column label="查看促销员电话" align="center">
            <template slot-scope="scope">
              <el-switch :disabled="auths.indexOf(2) < 0" v-model="scope.row.checkTelBool" @change="telTool(scope.row)"
                         active-color="#8299dc" inactive-color="#ffffff"
                         :class="{switchBorder:!scope.row.checkTelBool}"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="关闭岗位" align="center">
            <template slot-scope="scope">
              <el-switch :disabled="auths.indexOf(2) < 0" v-model="scope.row.closePosFlg" @change="editClosePosFlg(scope.row)"
                         active-color="#8299dc" inactive-color="#ffffff"
                         :class="{switchBorder:!scope.row.closePosFlg}"/>
            </template>
          </el-table-column>
          <el-table-column label="招聘特权" align="center">
            <template slot-scope="scope">
              <el-switch :disabled="auths.indexOf(2) < 0" v-model="scope.row.recruitmentPrivilege" @change="editRecruitmentPrivilege(scope.row)"
                         active-color="#8299dc" inactive-color="#ffffff"
                         :class="{switchBorder:!scope.row.recruitmentPrivilege}"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="400">
            <template slot-scope="scope">
              <el-button type="text" size="small" :disabled="auths.indexOf(2) < 0" @click="handleExamine(scope.row)">
                查看页面权限
              </el-button>
              <span class="cutLine"></span>
              <el-button type="text" size="small" :disabled="auths.indexOf(2) < 0" @click="handleEdit(scope.row)">编辑
              </el-button>
              <span class="cutLine"></span>
              <el-button type="text" size="small" :disabled="auths.indexOf(2) < 0" @click="handleDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 40]"
                       :page-size="pageSize" layout="slot, total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>
    <!-- 创建角色弹窗 -->
    <el-dialog title="创建角色" :visible.sync="createNewRoleModal" :center="true" :show-close="false" width="780px"
               class="createLine">
      <el-form size="mini" class="roleInputBackColor">
        <el-form-item label="角色名称">
          <el-input v-model="createRoleName" placeholder="请输入角色名称..." :maxlength="12" class="rowName"></el-input>
          <span class="bottomFontColor">{{createRoleName.length}}/12字符</span>
        </el-form-item>
        <el-form-item label="备注" label-width="68px">
          <el-input type="textarea" :rows="6" placeholder="请输入备注..." v-model="createRoleMark" resize="none"
                    :maxlength="140"></el-input>
          <span class="bottomFontColor floatr">{{createRoleMark.length}}/140字符</span>
        </el-form-item>
        <el-form-item label="可查看页面">
          <!-- {{checkTagList}} -->
          <el-tag v-if="item.webAuth === 2" class="createEditTag" v-for="(item ,index) in checkTagList" :key="index">
            <span>{{item.webName + '-编辑'}}</span>
          </el-tag>
          <el-tag v-if="item.webAuth === 1" class="createEditTag" v-for="(item ,index) in checkTagList" :key="index">
            <span>{{item.webName + '-查看'}}</span>
          </el-tag>
          <el-button round class="el-icon-plus roleAddBtn" @click="reviseTag=true">&nbsp增加</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button class="roleCancelBtn" @click="createNewRoleCancel">取消</el-button>
        <el-button class="roleDefineBtn" @click="createNewRole" :disabled="new_ACKDisabled">确定</el-button>
      </div>
    </el-dialog>
    <!-- 查看页面权限弹窗 -->
    <el-dialog class="limitPage" width="780px" title="页面权限查看" :visible.sync="handleView" :center="true"
               :show-close="false" @close="initTagInfo">
      <el-collapse accordion>
        <el-collapse-item v-for="(item, index) in tagInfo" :key="index">
          <template slot="title">
            <span class="limitPageTagTopTitle">{{item.title}}</span>
            <el-tag v-if="childTitle.webAuth === 2" class="createLimitPageTag" v-for="(childTitle ,index) in item.info"
                    :key="index">
              <span>{{childTitle.webName + '-编辑'}}</span>
            </el-tag>
            <el-tag v-if="childTitle.webAuth === 1" class="bottomLimitPageTag" v-for="(childTitle ,index) in item.info"
                    :key="index">
              <span>{{childTitle.webName + '-查看'}}</span>
            </el-tag>
          </template>
          <div>
            <el-tag  v-for="(childTitle, index) in item.info" :key="index" class="unCreateLimitPageTag"
                    :class="[{bottomLimitPageTag:childTitle.webAuth === 1},{topLimitPageTag:childTitle.webAuth === 2}]">
              <span class="limitPageTagTitle">{{childTitle.webName}}</span>
            </el-tag>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div slot="footer">
        <el-button class="limitPageCancelBtn" @click="colseViewPageTag">取消</el-button>
        <el-button class="limitPageDefineBtn" @click="colseViewPageTag">确定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑页面权限 -->
    <el-dialog class="limitPage" width="780px" title="页面权限" :visible.sync="reviseTag" top="4vh"
               :show-close="false">
      <el-collapse accordion>
        <div class="common-search" style="margin-bottom:10px;">
          <el-form :inline="true" class="formInline" size="mini">
            <el-form-item label="PLUS-CRM页面" class="limitPageTop">
              <el-input v-model="webName" placeholder="请输入页面名称进行模糊搜索" style="width:200px;margin-right:10px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="search-btn" @click="searchEditLimit">筛选</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-collapse accordion>


          <el-collapse-item v-for="(item, index) in tagInfo" :key="index" v-show="item.show">
            <template slot="title">
                <span class="limitPageTagTopTitle">{{item.title}}</span>
                <el-tag v-if="childTitle.webAuth === 2" class="topLimitPageTag notChangePD" v-for="(childTitle ,index) in item.info"
                        :key="index">
                  {{childTitle.webName + '-编辑'}}
                  <i class="el-icon-circle-close-outline editLimitTagClose" @click="childTitle.webAuth = null"></i>
                </el-tag>
                <el-tag v-if="childTitle.webAuth === 1" class="bottomLimitPageTag notChangePD"
                        v-for="(childTitle ,index) in item.info" :key="index">
                  {{childTitle.webName + '-查看'}}
                  <i class="el-icon-circle-close-outline viewLimitTagClose" @click="childTitle.webAuth = null"></i>
                </el-tag>
            </template>
            <div>
              <el-tag v-if="index<6" v-for="(childTitle, index) in item.info" v-show="childTitle.webShow" :key="index"
                      class="limitPageTag"
                      :class="[{bottomLimitPageTag:childTitle.viewTool},{topLimitPageTag:childTitle.editTool},{bottomLimitPageTag:childTitle.webAuth===0},{topLimitPageTag:childTitle.webAuth===1}]">
                <span class="limitPageTagTitle">{{childTitle.webName}}</span>
                <el-checkbox v-if="childTitle.webName != '黑名单'" class="limitPageCheckEdit" size="medium" label="编辑"
                             v-model="childTitle.webAuth" :true-label="2"
                             @change="childTitle.viewTool=false"></el-checkbox>
                <el-checkbox class="limitPageCheckView" size="medium" label="查看" v-model="childTitle.webAuth"
                             :true-label="1" :disabled="childTitle.webAuth === 2"></el-checkbox>
              </el-tag>
              <br>
              <el-tag v-if="index>=6" v-for="(childTitle, index) in item.info" v-show="childTitle.webShow" :key="index"
                      class="limitPageTag"
                      :class="[{bottomLimitPageTag:childTitle.viewTool},{topLimitPageTag:childTitle.editTool},{bottomLimitPageTag:childTitle.webAuth===0},{topLimitPageTag:childTitle.webAuth===1}]">
                <span class="limitPageTagTitle">{{childTitle.webName}}</span>
                <el-checkbox v-if="childTitle.webName != '黑名单'" class="limitPageCheckEdit" size="medium" label="编辑"
                             v-model="childTitle.webAuth" :true-label="2"
                             @change="childTitle.viewTool=false"></el-checkbox>
                <el-checkbox class="limitPageCheckView" size="medium" label="查看" v-model="childTitle.webAuth"
                             :true-label="1" :disabled="childTitle.webAuth === 2"></el-checkbox>
              </el-tag>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-collapse>
      <div slot="footer">
        <el-button class="limitPageCancelBtn" @click="reviseTag=false">取消</el-button>
        <el-button class="limitPageDefineBtn" @click="saveCheckedTags">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog class="limitPage" title="角色编辑" :visible.sync="editRowDialog" width="780px" :center="true"
               :show-close="false">
      <el-form label-position="left" label-width="90px" v-model="editRowObj" inline size="mini"
               class="table-expand-form" style="margin: 20px 30px 0 30px" v-loading="editLoading">
        <el-form-item label="角色名称">
          <el-input v-model="editRowObj.aaa" placeholder="请输入角色名称..." @input='check' :maxlength="12"
                    class="rowName"></el-input>
          <span class="bottomFontColor">{{aaaLength}}/12字符</span>
          <!--  <span style="opacity:0"> {{num}}  </span>-->
          <!-- <span class="bottomFontColor">5~12字符</span> -->
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editRowObj.bbb" @input='checkb' placeholder="请输入备注..." :maxlength="140"
                    class="rowRemark"></el-input>
          <span class="bottomFontColor">{{bbbLength}}/140字符</span>
          <!-- <span class="bottomFontColor">5~140字符</span> -->
        </el-form-item>
        <el-form-item label="可查看页面">
          <el-tag v-show="item.webAuth === 2" class="createEditTag" v-for="(item ,index) in checkTagList" :key="index">
            <span>{{item.webName + '-编辑'}}</span>
          </el-tag>
          <el-tag v-show="item.webAuth === 1" class="createEditTag" v-for="(item ,index) in checkTagList" :key="index">
            <span>{{item.webName + '-查看'}}</span>
          </el-tag>
          <el-button round class="reviseBtn" @click="reviseRowBtn(editRowObj)">修改</el-button>
        </el-form-item>
      </el-form>
      <el-row class="tableBottomBtn">
        <el-col :span="4" :xs="8" :sm="6" :md="6" :lg="4" :xl="4" :offset="10">
          <el-button size="mini" class="rowCancel" @click="rowHandleCancel(editRowObj)">取消</el-button>
          <el-button size="mini" class="rowSave" @click="rowHandleSave(editRowObj)" :disabled="editLoading">保存
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
  import utils from '../../common/js/util.js'

  export default {
    name: "limitManager",
    data() {
      return {
        new_ACKDisabled: false,
        //默认隐藏创建角色框
        createNewRoleModal: false,

        //创建角色数据
        createRoleName: "",
        createRoleMark: "",
        //页面权限编辑输入框
        webName: "",


        //页面权限查看中的信息 等后台数据确定后 再进行修改
        tagInfo: [
          {
            title: "dashboard",
            show: true,
            webId: 22,
            info: [
              {
                webId: 25,
                webName: "dashboard",
                webShow: true,
                pid: 22,
                webLevel: 2,
                webAuth: null,
              }
            ]
          },
          {
            title: "人员中心",
            show: true,
            webId: 3,
            info: [
              {
                webId: 1,
                webName: "促销员库",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 2,
                webName: "基础中心",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 17,
                webName: "黑名单",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 18,
                webName: "导入评分数据",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              }
              ,{
                webId: 33,
                webName: "快决策问卷",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 34,
                webName: "拨号记录",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 35,
                webName: "项目配置",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 42,
                webName: "兼职签约查询",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 44,
                webName: "QHR人员库",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 47,
                webName: "灰名单查询",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 52,
                webName: "灵工签约记录",
                webShow: true,
                pid: 3,
                webLevel: 2,
                webAuth: null,
              }
            ]
          },
          {
            title: "工作广场",
            show: true,
            webId: 4,
            info: [
              {
                webId: 5,
                webName: "岗位发布",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 6,
                webName: "岗位管理",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 39,
                webName: "客户配置",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 40,
                webName: "供应商置换",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 41,
                webName: "虚拟项目维护",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 43,
                webName: "任务配置字段",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 45,
                webName: "自定义项目类型",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 46,
                webName: "客户项目维护",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              },{
                webId: 55,
                webName: "项目灵工记录",
                webShow: true,
                pid: 4,
                webLevel: 2,
                webAuth: null,
              }
            ]
          },
          {
            title: "配置管理",
            show: true,
            webId: 48,
            info: [
              {
                webId: 49,
                webName: "美赞人员映射",
                webShow: true,
                pid: 49,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 50,
                webName: "TOMD",
                webShow: true,
                pid: 50,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 51,
                webName: "长促白名单",
                webShow: true,
                pid: 51,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 53,
                webName: "协议授权配置",
                webShow: true,
                pid: 53,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 54,
                webName: "灵工项目映射",
                webShow: true,
                pid: 54,
                webLevel: 2,
                webAuth: null,
              }
            ]
          },
          {
            title: "任务中心",
            show: true,
            webId: 28,
            info: [
              {
                webId: 29,
                webName: "发布任务",
                webShow: true,
                pid: 28,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 30,
                webName: "任务审核",
                webShow: true,
                pid: 28,
                webLevel: 2,
                webAuth: null,
              }
            ]
          },
          // {
          //   title: "活动中心",
          //   show: true,
          //   webId: 15,
          //   info: [
          //     {
          //       webId: 16,
          //       webName: "活动中心",
          //       webShow: true,
          //       pid: 15,
          //       webLevel: 2,
          //       webAuth: null,
          //     }
          //   ]
          // },
          // {
          //   title: "积分商城",
          //   show: true,
          //   info: []
          // },
          {
            title: "评估体系",
            show: true,
            webId: 19,
            info: [
              {
                webId: 20,
                webName: "体系配置",
                webShow: true,
                pid: 19,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 21,
                webName: "评估明细查询",
                webShow: true,
                pid: 19,
                webLevel: 2,
                webAuth: null,
              }
            ]
          },
          {
            title: "标签体系",
            show: true,
            webId: 7,
            info: [
              {
                webId: 8,
                webName: "标签管理",
                webShow: true,
                pid: 7,
                webLevel: 2,
                webAuth: null,
              },
              // {
              //   webId: 9,
              //   webName: "岗位类型",
              //   webShow: true,
              //   pid: 7,
              //   webLevel: 2,
              //   webAuth: null,
              // },
              {
                webId: 10,
                webName: "项目标签配置",
                webShow: true,
                pid: 7,
                webLevel: 2,
                webAuth: null,
              },
              // {
              //   webId: 11,
              //   webName: "自我标签",
              //   webShow: true,
              //   pid: 7,
              //   webLevel: 2,
              //   webAuth: null,
              // }
            ]
          },
          {
            title: "权限管理",
            show: true,
            webId: 12,
            info: [
              {
                webId: 13,
                webName: "角色管理",
                webShow: true,
                pid: 12,
                webLevel: 2,
                webAuth: null,
              },
              {
                webId: 14,
                webName: "用户管理",
                webShow: true,
                pid: 12,
                webLevel: 2,
                webAuth: null,
              }
            ]
          },
          {
            title: "筛选项配置",
            show: true,
            webId: 23,
            info: [
              {
                webId: 24,
                webName: "筛选项配置",
                webShow: true,
                pid: 23,
                webLevel: 2,
                webAuth: null,
              }
            ]
          },
          {
            title: "友情链接",
            show: true,
            webId: 36,
            info: [
              {
                webId: 37,
                webName: "工作快讯",
                webShow: true,
                pid: 36,
                webLevel: 2,
                webAuth: null,
              }
            ]
          }
        ],
        //默认隐藏每一行修改弹窗
        reviseTag: false,
        //默认隐藏查看页面权限弹窗
        handleView: false,

        //默认显示第一页的数据
        pageNo: 1,
        //默认显示10条数据
        pageSize: 10,
        //总页数
        total: null,

        //table请求数据
        formData: {
          //角色名称
          roleName: "",
          //传参的默认页数未1
          pageNo: 1,
          //传参的默认页数未10
          pageSize: 10
        },
        //数据加载后这个数组的内容就是数据
        tableData: [],
        //默认‘拼命加载’显示
        listLoading: true,

        // 已选择的页面
        checkTagList: [],

        // 单行编辑dialog标志位
        editRowDialog: false,
        editLoading: false,
        editRowObj: {
          roleName: [],
          roleRemark: [],
          aaa: '',
          bbb: '',
        },
        aaaLength: 0,
        bbbLength: 0,
        // 页面内权限
        auths: [],
        // num:0
      };
    },
    mounted() {
      //页面激活后，请求数据
      this.getData();

      this.getAuth()
    },
    methods: {
      //工具类，弹框简写
      myNotify(_this,type, normal, or) {
        utils.myNotify(_this,type, normal, or)
      },
      check() {
        this.aaaLength = this.editRowObj.aaa ? this.editRowObj.aaa.length : 0
      },
      checkb() {
        this.bbbLength = this.editRowObj.bbb ? this.editRowObj.bbb.length : 0
      },
      createNewRoleModalTrue() {
        this.createNewRoleModal = true
        this.checkTagList = []
      },
      //查看电话权限
      telTool(val) {
        let webId = []
        this.handleExamine(val)
        this.handleView = false
        this.checkTagList.forEach(item => {
          webId.push({
            webId: item.webId,
            webAuth: item.webAuth
          })
        })
        this.$http({
          method: "POST",
          url: "/rest/role/updateRoleAuthCheckTel",
          data: {
            id: val.id,
            roleName: val.roleName,
            roleRemark: val.roleRemark,
            checkTelBool: val.checkTelBool,
            webId: webId
          }
        }).then(res => {
          //搜索时没有权限，进行提示
          if (res.data.status == 460) {
            this.myNotify(this,'error', res, '查询失败，请稍后重试')
            return false
          }
          this.myNotify(this,'success', res, '操作成功')
          this.getData();
          this.initTagInfo()
        }).catch(err => {
          if (err.response.status == 456) {
            this.myNotify(this,'error', '此角色无任何页面权限,请先添加页面权限')
            val.checkTelBool = !val.checkTelBool
            return false
          }
          this.myNotify(this,'error', err.response, '查询失败，请稍后重试')
        });
      },
      //取消创建
      createNewRoleCancel() {
        this.createRoleName = "";
        this.createRoleMark = "";
        this.createNewRoleModal = false;
        this.initTagInfo();
      },

      //编辑模糊搜索
      blurrySearch(data) {
        // for (var i = 0; i < data.length; i++) {
        //   for (var j = 0; j < this.tagInfo.length; j++) {
        //     for(var k = 0; k < this.tagInfo[j].info.length; k ++) {
        //       this.tagInfo[j].show = false
        //       this.tagInfo[j].info[k].webShow = false
        //       if (data.webLevel === 1) {
        //         this.tagInfo[j].show = true
        //         this.tagInfo[j].info[k].webShow = true
        //         console.log(111)
        //       } else if (data.webLevel === 2) {
        //         this.tagInfo[j].info[k].webShow = true
        //       }
        //     }
        //   }
        // }
      },

      //模糊检索
      searchEditLimit() {
        this.$http({
          method: "GET",
          url: "/rest/role/searchRoleAuth",
          params: {
            webName: this.webName
          }
        }).then(res => {
          this.blurrySearch(res.data);
        }).catch(err => {
          this.myNotify(this,'error', err.response, '操作失败，请稍后重试')
        })
      },
      //创建角色方法
      createNewRole() {
        if (this.checkTagList.length == 0) {
          this.myNotify(this,'error', '请选择页面权限')
        } else if (!this.createRoleName && this.createRoleName !== 0) {
          this.myNotify(this,'error', '请填写角色名称')
        } else {
          let webId = []
          this.checkTagList.forEach(item => {
            webId.push({
              webId: item.webId,
              webAuth: item.webAuth
            })
          })
          this.new_ACKDisabled = true;
          this.$http({
            method: "POST",
            url: "/rest/role/saveUpdateRole",
            data: {
              id: null,
              roleName: this.createRoleName,
              roleRemark: this.createRoleMark,
              checkTelBool: true,
              webId: webId
            }
          }).then(res => {
            this.new_ACKDisabled = false;
            //关闭创建角色弹窗
            let status = res.data.status
            if (status == 400 || status == 460) {
              this.myNotify(this,'error', res, '操作失败，请稍后重试')
            } else {
              this.myNotify(this,'success', res, '操作成功')
              this.createNewRoleModal = false
              this.getData()
            }
          }).catch(err => {
            this.new_ACKDisabled = false;
            this.myNotify(this,'error', err.response, '操作失败，请稍后重试')
          })
        }
      },
      //每一行的保存按钮
      rowHandleSave(row) {
        let webId = []
        this.checkTagList.forEach(item => {
          webId.push({
            webId: item.webId,
            webAuth: item.webAuth
          })
        })
        this.editLoading = true;
        this.$http({
          method: "POST",
          url: "/rest/role/saveUpdateRole",
          data: {
            id: row.id,
            roleName: this.editRowObj.aaa,
            roleRemark: this.editRowObj.bbb,
            checkTelBool: row.checkTelBool,
            webId: webId
          }
        }).then(res => {
          //先将展开一行的方法，设置为false
          // this.$refs["table"].toggleRowExpansion(row, false);
          this.editRowDialog = false;
          this.editLoading = false;
          this.initTagInfo();
          this.myNotify(this,'success', res, '操作成功')
          this.getData();
        }).catch(err => {
          this.myNotify(this,'error', err.response, '操作失败，请稍后重试')
          this.editLoading = false;
        })
      },
      //每一行的取消按钮
      rowHandleCancel(row) {
        this.initTagInfo();
        this.editRowDialog = false
        // this.$refs["table"].toggleRowExpansion(row, false);
      },

      //编辑展开后，修改按钮
      reviseRowBtn(row) {
        this.checkTagList = []
        //编辑权限弹窗
        this.reviseTag = true;
        this.handleEdit(row)
      },
      // 修改保存标签到row里面
      saveCheckedTags() {
        this.checkTagList = []
        this.tagInfo.forEach(t => {
          t.info.forEach(i => {
            if (i.webAuth === 1 || i.webAuth === 2) {
              this.checkTagList.push(i)
            }
          })
        })
        this.reviseTag = false
      },
      //删除
      handleDelete(row) {
        let roleId = row.id
        this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: "POST",
            url: "/rest/sysUser/deleteUserRole",
            params: {
              roleId: roleId
            }
          }).then(() => {
            // 角色删除后相应的用户角色置null
            this.$http({
              method: "POST",
              url: "/rest/role/deleteRole",
              data: {
                id: row.id
              }
            }).then(res => {
              this.getData()
              this.myNotify(this,'success', res, '操作成功')
            })
          }).catch(err => {
            this.myNotify(this,'error', err.response, '查询失败，请稍后重试')
          })
        })
      },
      //请求数据
      getData() {
        //加载的时候，让‘拼命加载’隐藏
        this.listLoading = true;
        this.$http({
          method: "GET",
          url: "/rest/role/getRole",
          params: this.formData
        }).then(res => {
          this.listLoading = false;
          this.tableData = res.data;
          this.total = res.data.length > 0 ? Number(res.data[0].numList) : 0;
        }).catch(err => {
          if (err.response) {
            this.myNotify(this,'error', err.response, '查询失败，请稍后重试')
          }
          this.listLoading = false;
        })
      },
      getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 13,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          let data = res.data
          data.forEach(item => {
            this.auths.push(item.auth)
          })
        }).catch(err => {
          this.myNotify(this,'error', err.response, '查询失败，请稍后重试')
        })
      },
      handleSizeChange(val) {
        //更改页面数据条数
        this.formData.pageSize = val;
        //更改新的页面数据条数后，重新请求数据
        this.getData();
      },
      handleCurrentChange(val) {
        //更改页数
        this.formData.pageNo = val;
        //更改新的页数后，重新请求数据
        this.getData();
      },

      //编辑
      handleEdit(row) {
        // console.log(this.tableData)
        // this.tableData.forEach(t => {
        //   if (t.id !== row.id) {
        //     // this.$refs["table"].toggleRowExpansion(t, false)
        //     this.editRowDialog = true
        //     this.editRowObj = row
        //   }
        // })

        this.editRowDialog = true
        this.editRowObj = row
        this.editRowObj.aaa = row.roleName
        this.aaaLength = this.editRowObj.aaa ? this.editRowObj.aaa.length : 0
        this.editRowObj.bbb = row.roleRemark
        this.bbbLength = this.editRowObj.bbb ? this.editRowObj.bbb.length : 0
        // console.log(this.editRowObj)
        this.editLoading = true;
        this.$http({
          method: "GET",
          url: "/rest/role/getRoleAuth",
          params: {
            id: row.id
          }
        }).then(res => {
          this.checkResTag(res.data)
          this.editLoading = false
          // this.$refs["table"].toggleRowExpansion(row, true)
        }).catch(err => {
          this.myNotify(this,'error', err.response, '查询失败，请稍后重试')
          this.editLoading = false
        })
      },

      //页面权限查看
      handleExamine(row) {
        this.handleView = true;
        this.tableData.forEach(t => {
          if (t.id !== row.id) {
            this.$refs["table"].toggleRowExpansion(t, false)
          }
        })
        this.$http({
          method: "GET",
          url: "/rest/role/getRoleAuth",
          params: {
            id: row.id
          }
        }).then(res => {
          this.checkResTag(res.data)
        }).catch(err => {
          this.myNotify(this,'error', err.response, '查询失败，请稍后重试')
        })
      },
      checkResTag(data) {
        this.checkTagList = []
        data.forEach(d => {
          if (d.webAuth === 1 || d.webAuth === 2) {
            this.checkTagList.push(d)
          }
          this.tagInfo.forEach(t => {
            t.info.forEach(i => {
              if (i.webId === d.webId) {
                i.webAuth = d.webAuth
              }
            })
          })
        })
      },

      //初始化tagInfo
      initTagInfo() {
        this.webName = "";
        for (var i = 0; i < this.tagInfo.length; i++) {
          this.tagInfo[i].show = true;
          for (var j = 0; j < this.tagInfo[i].info.length; j++) {
            this.tagInfo[i].info[j].webShow = true
            this.tagInfo[i].info[j].webAuth = null
          }
        }
      },

      //关闭页面权限查看头部tag
      colseViewPageTag() {
        this.handleView = false;
      },
      // 修改关闭岗位权限
      editClosePosFlg(val) {
        var closePosFlg;
        if(val.closePosFlg) {
          closePosFlg = 1;
        }else {
          closePosFlg = 0;
        }
        this.$http({
          method: "POST",
          url: "/rest/role/updateClosePosFlag",
          params:{
            id: val.id,
            flag: closePosFlg
          }
        }).then(res => {
          this.myNotify(this,'success', res, '操作成功');
        }).catch(err => {
          this.getData();
          this.myNotify(this,'error', err.response, '更新失败，请稍后重试');
        })
      },
      // 修改招聘特权
      editRecruitmentPrivilege(val) {
        var recruitmentPrivilege;
        if(val.recruitmentPrivilege) {
          recruitmentPrivilege = 1;
        }else {
          recruitmentPrivilege = 0;
        }
        this.$http({
          method: "POST",
          url: "/rest/role/updateRecruitmentPrivilege",
          params:{
            id: val.id,
            flag: recruitmentPrivilege
          }
        }).then(res => {
          this.myNotify(this,'success', res, '操作成功');
        }).catch(err => {
          this.getData();
          this.myNotify(this,'error', err.response, '更新失败，请稍后重试');
        })
      }
    }
  };
</script>
<style scoped>
  /* 操作里的分割线 */
  .cutLine {
    border-right: 1px solid #82bc82;
    margin: 0 10px;
    position: relative;
    right: 1px;
  }

  /* 每一行展开后取消按钮样式 */
  .rowCancel {
    background-color: #dedede;
    color: #666666;
    border: none;
  }

  /* 每一行展开后保存按钮样式 */
  .rowSave {
    background-color: #8299dc;
    color: #ffffff;
    border: none;
  }

  /* 每一行展开后角色名称input框的长度 */
  .rowName {
    width: 160px;
    margin-right: 10px;
  }

  /* 每一行展开后备注input框的长度 */
  .rowRemark {
    width: 500px;
    margin-right: 10px;
  }

  /* 每一行展开后修改按钮的样式 */
  .reviseBtn,
  .reviseBtn:active {
    color: #8198db;
    border-color: #8198db;
    background-color: #ffffff;
    width: 60px;
    height: 30px;
  }

  /* 创建新角色按钮样式 */
  .newRole {
    background-color: #8198db;
    border-radius: 20px;
  }

  /* 创建角色框中的增加按钮样式 */
  .roleAddBtn,
  .roleAddBtn:active {
    color: #8198db;
    border-color: #8198db;
    background-color: #ffffff;
    width: 80px;
    height: 30px;
  }

  /* 创建角色中的确定按钮样式 页面权限中的确定按钮样式*/
  .roleDefineBtn,
  .limitPageDefineBtn {
    background: #2d2c7a;
    height: 30px;
    color: #ffffff;
    border: none;
    font-size: 12px;
    padding: 7px 18px;
  }

  /* 创建角色中的取消按钮样式 */
  .roleCancelBtn,
  .roleCancelBtn:hover {
    height: 30px;
    color: #666666;
    border: none;
    font-size: 12px;
    padding: 7px 18px;
    background-color: #ffffff;
  }

  /* 页面权限中的取消按钮样式 */
  .limitPageCancelBtn,
  .limitPageCancelBtn:hover {
    height: 30px;
    color: #666666;
    border: none;
    font-size: 12px;
    padding: 7px 18px;
    background-color: #ffffff;
  }

  /* 查看页面权限样式 */
  .unCreateLimitPageTag,
  .limitPageTag {
    background-color: #ffffff;
    color: #8299dc;
    border: none;
    padding: 0 10px;
    border-radius: 20px;
    margin-bottom: 10px;
    margin-right: 8px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }

  /* 页面权限标签样式 */
  .createLimitPageTag,
  .topLimitPageTag {
    background-color: #8299dc;
    color: #ffffff;
    border: none;
    padding: 0 10px;
    border-radius: 20px;
    /* margin-bottom: 10px; */
    margin-right: 8px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }

  .bottomLimitPageTag {
    background-color: #81bc82;
    color: #ffffff;
    border: none;
    padding: 0 10px;
    border-radius: 20px;
    /* margin-bottom: 10px; */
    margin-right: 8px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }

  /* 删除编辑标签样式hover时 右侧X */
  .editLimitTagClose {
    background-color: #8299dc;
    color: #ffffff;
    font-weight: 100;
    margin-left: 10px;
    font-size: 20px;
    position: relative;
    top: 3px;
  }

  /* 删除查看标签的样式hover时 右侧X */
  .viewLimitTagClose {
    font-weight: 100;
    margin-left: 10px;
    font-size: 20px;
    position: relative;
    top: 3px;
  }

  .limitPageTag:hover {
    background-color: #8299dc;
    color: #ffffff;
  }

  /* 鼠标hover时展示编辑checkbox */
  .limitPageTag:hover .limitPageCheckEdit {
    color: #ffffff;
    display: inline-block;
  }

  /* 鼠标hover时展示查看checkbox */
  .limitPageTag:hover .limitPageCheckView {
    color: #ffffff;
    display: inline-block;
  }

  /* 鼠标hover时展示已有标签的X */
  .topLimitPageTag:hover:not(.notChangePD) .editLimitTagClose {
    display: inline-block;
  }

  /* 鼠标hover时改变已有权限标签的样式 */
  .topLimitPageTag:hover:not(.notChangePD) {
    padding: 0 5px 0 10px;
  }

  .bottomLimitPageTag:hover:not(.notChangePD) .viewLimitTagClose {
    display: inline-block;
    background-color: #ffffff;
    color: #81bc82;
  }

  .bottomLimitPageTag:hover:not(.notChangePD) {
    padding: 0 5px 0 10px;
  }

  /* 鼠标hover时调整标签内容位置 */
  .limitPageTag:hover .limitPageTagTitle {
    margin-right: 20px;
  }

  /* 鼠标离开时让展示的编辑、查看隐藏 */
  .limitPageCheckEdit,
  .limitPageCheckView,
  .editLimitTagClose,
  .viewLimitTagClose {
    display: none;
  }

  /* 页面权限顶部输入框位置 */
  .limitPageTop {
    margin-left: 20px;
  }

  /* 输入框底部字体颜色 */
  .bottomFontColor {
    color: #bfbfbf;
  }

  /* 页面权限 查看页面权限 每个标题的位置 */
  .limitPageTagTopTitle {
    margin-right: 15px;
    white-space: nowrap;
  }

  /* table点击编辑后显示的取消、确定按钮的位置 */
  .tableBottomBtn {
    margin: 0 20px;
    padding-bottom: 20px;
  }

  /* table中点击编辑之后和创建角色 展示的可查看页面的标签样式 */
  .tableViewTag,
  .createEditTag {
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 0 10px;
    border-radius: 20px;
  }
  /* .el-collapse-item__header{} */
</style>
<style lang="scss" scoped>
/deep/ .el-collapse-item__header{
  flex-wrap: wrap;
  height: 100%;
} 
/deep/ .el-icon-arrow-right{
  position: absolute;
    right: 20px;
}
/deep/ .el-collapse-item{
  padding: 4px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/limit/limitManager.vue